import { AutogenModelRmSpcities, AutogenRowRmSpcities } from "./autogen/AutogenModelRmSpcities";

export class ModelRmSpcities extends AutogenModelRmSpcities<RowRmSpcities> {
	constructor() {
		super(RowRmSpcities);
	}
}

export class RowRmSpcities extends AutogenRowRmSpcities {
}